/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ReaderFragment } from "relay-runtime";

import { FragmentRefs } from "relay-runtime";
export type UserType = "TYPE_ADMIN" | "TYPE_EMPLOYEE" | "TYPE_UNSPECIFIED" | "%future added value";
export type App_user = {
    readonly id: string;
    readonly type: UserType;
    readonly customer: {
        readonly id: string;
    };
    readonly " $fragmentRefs": FragmentRefs<"App_initializeServices_user" | "SideNav_user">;
    readonly " $refType": "App_user";
};
export type App_user$data = App_user;
export type App_user$key = {
    readonly " $data"?: App_user$data;
    readonly " $fragmentRefs": FragmentRefs<"App_user">;
};



const node: ReaderFragment = (function () {
    var v0 = {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "id",
        "storageKey": null
    } as any, v1 = {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "name",
        "storageKey": null
    } as any;
    return {
        "argumentDefinitions": [],
        "kind": "Fragment",
        "metadata": null,
        "name": "App_user",
        "selections": [
            (v0 /*: any*/),
            {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "type",
                "storageKey": null
            },
            {
                "alias": null,
                "args": null,
                "concreteType": "Customer",
                "kind": "LinkedField",
                "name": "customer",
                "plural": false,
                "selections": [
                    (v0 /*: any*/)
                ],
                "storageKey": null
            },
            {
                "kind": "InlineDataFragmentSpread",
                "name": "App_initializeServices_user",
                "selections": [
                    (v0 /*: any*/),
                    {
                        "alias": null,
                        "args": null,
                        "kind": "ScalarField",
                        "name": "firstName",
                        "storageKey": null
                    },
                    (v1 /*: any*/),
                    {
                        "alias": null,
                        "args": null,
                        "kind": "ScalarField",
                        "name": "email",
                        "storageKey": null
                    },
                    {
                        "alias": null,
                        "args": null,
                        "concreteType": "Organization",
                        "kind": "LinkedField",
                        "name": "organizations",
                        "plural": true,
                        "selections": [
                            (v0 /*: any*/),
                            (v1 /*: any*/),
                            {
                                "alias": null,
                                "args": null,
                                "kind": "ScalarField",
                                "name": "headcount",
                                "storageKey": null
                            }
                        ],
                        "storageKey": null
                    }
                ]
            },
            {
                "args": null,
                "kind": "FragmentSpread",
                "name": "SideNav_user"
            }
        ],
        "type": "User",
        "abstractKey": null
    } as any;
})();
(node as any).hash = 'a0316f17735bac9006a4c3b9977d3d44';
export default node;
